import * as React from 'react'
import { useTheme } from '@mui/material'

const GoToProjectIcon = (props) => {
  const theme = useTheme()

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none" {...props}>
      <path
        d="M10.9285 10.5H4.92847V13.5H10.9285V16.5L15.4285 12L10.9285 7.5V10.5ZM9.42847 9V7.5C9.42847 6.67157 10.1 6 10.9285 6C11.3263 6 11.7078 6.15804 11.9891 6.43934L16.4891 10.9393C17.0749 11.5251 17.0749 12.4749 16.4891 13.0607L11.9891 17.5607C11.4033 18.1464 10.4536 18.1464 9.86781 17.5607C9.5865 17.2794 9.42847 16.8978 9.42847 16.5V15H4.92847C4.10004 15 3.42847 14.3284 3.42847 13.5V10.5C3.42847 9.67157 4.10004 9 4.92847 9H9.42847ZM20.6785 4.5C21.0927 4.5 21.4285 4.83579 21.4285 5.25V18.75C21.4285 19.1642 21.0927 19.5 20.6785 19.5C20.2643 19.5 19.9285 19.1642 19.9285 18.75V5.25C19.9285 4.83579 20.2643 4.5 20.6785 4.5Z"
        fill={props.color ? props.color : theme.palette.icon.dark.color}
      />
    </svg>
  )
}
export default GoToProjectIcon
